<template>
  <GestionBaseObjetivo />
</template>
<script>
import GestionBaseObjetivo from "./components/GestionBaseObjetivo";
export default {
  components: { GestionBaseObjetivo },
};
</script>